<template>
  <div class="modal-container clearfix">
    <div class="add-box clearfix">
      <table-header @add="insertEvent" @remove="removeEvent" @copy="paste"></table-header>
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          align="center"
          :data="tableData"
          :edit-rules="tableRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearTableV"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="userName" title="客户名称" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>客户名称
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.userName" placeholder="必填" @blur="clearTableV"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="companyName" title="所属公司" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>所属公司
          </template>
          <template v-slot="{ row }">
            <platform-corp :row="row" :field="'companyName'" :placeholder="'请选择所属公司'"></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column field="realName" title="姓名" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>姓名
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.realName" placeholder="请输入姓名"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="identiNum" title="身份证号码" width="150">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.identiNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bindAccName" title="结算账户" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>结算账户
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.bindAccName" placeholder="请输入结算账户"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bindAccNum" title="结算银行卡帐号" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>结算银行卡帐号
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.bindAccNum" placeholder="请输入结算银行卡帐号"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="bindOpenBankName" title="结算开户行" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>结算开户行
          </template>
          <template v-slot="scope">
            <vxe-pulldown :ref="'bankDown'+scope.$rowIndex" transfer>
              <template v-slot>
                <vxe-input
                    v-model="scope.row.bindOpenBankName"
                    placeholder="请选择结算开户银行"
                    @focus="bankFocusEvent('bankDown'+scope.$rowIndex)"
                    @keyup="bankKeyupEvent(scope.row)"
                ></vxe-input>
              </template>
              <template v-slot:dropdown>
                <div class="my-dropdown1">
                  <div
                      class="list-item1"
                      v-for="item in bankList"
                      :key="item.id"
                      @click="bankSelectEvent(item,scope.row,'bankDown'+scope.$rowIndex)"
                  >
                    <i class="fa fa-user-o"></i>
                    <span>{{ item.orgName }}</span>
                  </div>
                </div>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isCrossLine" title="是否跨行" width="150">
          <template v-slot:header>
            <span style="color: red">*</span>是否跨行
          </template>
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.isCrossLine"
                placeholder="请选择"
                :options="cross_line"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent">上传导入文件</Button>
      <Button status="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from '@/apiProvider';
  import XLSX from "xlsx";
  import Message from "@/components/common/Message";
  import {getExcelTime, showLoading, hideLoading, isEmpty} from '@/utils/util';
  import TableHeader from "../../components/common/TableHeader";
  import md5 from "js-md5";
  import PlatformCorp from "@/components/common/PlatformCorp";

  export default {
    components: {Message, TableHeader, PlatformCorp},
    data() {
      const bankName = ({row}) => {
        if (row.bindOpenOrgNum === null) {
          return Promise.reject(
            new Error("请手动选择正确的结算开户银行")
          );
        }
      };
      return {
        tableData: [{
          no: 1,
          userName: null,
          companyName: null,
          realName: null,
          identiNum: null,
          bindAccName: null,
          bindAccNum: null,
          bindOpenBankName: null,
          bindOpenOrgNum: null,
          isCrossLine: "02",
          userType: 1,
        }],
        tableRules: {
          userName: [{required: true, message: "请输入客户名称"}],
          realName: [{required: true, message: "请输入姓名"}],
          // idno: [{required: true, message: "请输入身份证号码"}],
          // identiNum: [{required: true, message: "请输入证件号"}],
          bindAccName: [{required: true, message: "请输入结算账户"}],
          bindAccNum: [{required: true, message: "请输入银行账号"}],
          companyName: [{required: true, message: "请选择所属公司"}],
          bindOpenBankName: [{required: true, message: "请输入结算开户银行"}, {validator: bankName}],
          isCrossLine: [{required: true, message: "请选择是否跨行"}],
        },
        messageVisible: false,
        message: '',
        records: [],
        cross_line: [{
          label: '是',
          value: '02',
        }, {
          label: '否',
          value: '01',
        }],
        bankList: []
      }
    },
    mounted() {

    },
    methods: {
      bankFocusEvent(ref) {
        this.$refs[ref].showPanel();
      },
      bankKeyupEvent(row) {
        this.getBankListByName(row);
      },
      bankSelectEvent(obj, row, ref) {
        row.bindOpenBankName = obj.orgName;
        row.bindOpenOrgNum = obj.orgNum;
        this.$refs[ref].hidePanel();
      },
      bankBlurEvent(obj, row) {
        this.getBankListByName(row);
        if (this.bankList.length === 1) {
          row.bindOpenBankName = obj.orgName;
          row.bindOpenOrgNum = obj.orgNum;
        } else {
          row.bindOpenBankName = null;
          row.bindOpenOrgNum = null;
        }
      },
      async getBankListByName(row) {
        let name = row.bindOpenBankName;
        if (isEmpty(name)) {
          this.bankList = [];
          return
        }
        let res = await $api.finance.get(`cebBankOrg/searchOrgByName/${name}`);
        if (res.status === 1 && name == res.message) {
          this.bankList = res.data;
        }
      },
      impotEvent() {
        let self = this;
        this.$refs.xTable.readFile({
          types: ['xls', 'xlsx']
        }).then(evnt => {
          showLoading();
          const tableData = [];
          const files = evnt.target.files;
          const fileReader = new FileReader();
          fileReader.onload = (ev) => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, {type: 'binary'});
            const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
            // 解析数据
            let xlsxData = csvData.split('\n');
            //删除xlsx列名
            xlsxData.splice(0, 1);
            xlsxData.forEach((vRow) => {
              if (vRow) {
                const vCols = vRow.split(',');
                let crossLine = '';
                if (vCols[8] === '是') {
                  crossLine = '02'
                } else {
                  crossLine = '01'
                }
                const item = {
                  no: vCols[0],
                  userName: vCols[1],
                  companyName: vCols[2],
                  realName: vCols[3],
                  identiNum: vCols[4],
                  bindAccName: vCols[5],
                  bindAccNum: vCols[6],
                  bindOpenBankName: vCols[7],
                  bindOpenOrgNum: null,
                  isCrossLine: crossLine,
                  userType: 1,
                };

                tableData.push(item);
              }
            })
            this.tableData = tableData;
          }
          fileReader.readAsBinaryString(files[0]);
          setTimeout(() => {
            hideLoading();
          }, 1000);
        })
      },
      async insertEvent() {
        let record = {
          no: this.$refs.xTable.data.length + 1,
          userName: null,
          companyName: null,
          realName: null,
          identiNum: null,
          bindAccName: null,
          bindAccNum: null,
          bindOpenBankName: null,
          bindOpenOrgNum: null,
          isCrossLine: "02",
          userType: 1,
        };
        this.pushIntoTable(record);
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      paste() {
        let records = this.records.sort((a, b) => a.no - b.no);
        if (records.length > 0) {
          records.map(i => {
            let record = Object.assign({}, i)
            record.no = this.$refs.xTable.data.length + 1;
            this.pushIntoTable(record);
          })
        } else {
          this.$XModal.message({status: "error", message: "请选择需要复制的信息！"});
        }
      },
      pushIntoTable(record) {
        let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
        this.$refs.xTable.data.push(record);
        this.$refs.xTable.setActiveCell(newRow, "userName");
      },
      async validEvent() {
        let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
        return errMap ? false : true
      },
      removeEvent() {
        let records = this.records;
        if (records.length > 0) {
          if (this.$refs.xTable.tableData.length > 1) {
            this.$XModal.confirm("您确定要删除选中数据?").then((type) => {
              if (type === "confirm") {
                this.clearTableV()
                records.map(i => {
                  this.$refs.xTable.remove(i);
                  let key = this.$refs.xTable.data.indexOf(i);
                  this.$refs.xTable.data.splice(key, 1);
                })
                this.records = [];
                if (this.isExport === false) {
                  this.$refs.xTable.data.map((j, index) => {
                    j.no = index + 1;
                  })
                }
              }
            });
          } else {
            this.$XModal.alert({
              message: "已经是最后一条了！",
              status: "warning",
            });
          }
        } else {
          this.$XModal.message({status: "error", message: "请选择需要删除的信息！"});
        }
      },
      clearTableV() {
        this.$refs.xTable.clearValidate();
      },
      async commit() {
        let sts = await this.validEvent()
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return
        }
        this.save();
      },
      async save() {
        showLoading();
        let arr = JSON.parse(JSON.stringify(this.tableData));
        let res = await $api.finance.request('cebBusiMem/createMemMulti', arr);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('提交成功');
          this.close();
          this.$emit('afterSave');
        } else {
          let data = res.data;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + '序号' + (this.tableData[i.failArrayIndex].no) + '，' + i.failMsg + '\n';
            })
            let errorData = []
            res.data.forEach(failItem => {
              errorData.push(Object.assign({}, this.tableData[failItem.failArrayIndex]));
            })
            this.tableData = errorData;
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        }
      },
      closeMessage() {
        this.messageVisible = false;
      },
      close() {
        this.tableData = [{
          no: 1,
          userName: null,
          companyName: null,
          realName: null,
          identiNum: null,
          bindAccName: null,
          bindAccNum: null,
          bindOpenBankName: null,
          bindOpenOrgNum: null,
          isCrossLine: "02",
          userType: 1,
        }];
      }
    }
  }
</script>

<style scoped>
  .select >>> .ivu-select-arrow {
    position: absolute;
    top: 50% !important;
    right: 8px !important;
    line-height: 1;
    transform: translateY(-50%);
    font-size: 14px;
    color: #808695;
    transition: all .2s ease-in-out;
  }
</style>